var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('v-row',[_c('v-col',[_c('span',{staticStyle:{"font-size":"20px","color":"#424242"}},[_vm._v(_vm._s(_vm.$t("SetPermission")))])]),_c('v-col',{staticStyle:{"text-align":"right"}},[(_vm.editPermissionBtnShow)?_c('v-btn',{staticClass:"mr-3 text-capitalize",staticStyle:{"font-size":"16px","color":"#424242","border":"1px solid #c0c0c0","border-radius":"8px"},attrs:{"outlined":""},on:{"click":function($event){return _vm.editPermission('cancel')}}},[_vm._v(" "+_vm._s(_vm.$t("cancel"))+" ")]):_vm._e(),(!_vm.editPermissionBtnShow)?_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"16px","color":"#ffffff","border-radius":"8px","box-shadow":"unset"},attrs:{"width":"110","color":"#A6CC39"},on:{"click":function($event){return _vm.editPermission('edit')}}},[_vm._v(_vm._s(_vm.$t("edit")))]):_vm._e(),(_vm.editPermissionBtnShow)?_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"16px","color":"#ffffff","border-radius":"8px","box-shadow":"unset"},attrs:{"width":"110","color":"#A6CC39"},on:{"click":function($event){_vm.CreateorUpdatePermissionSetting(), _vm.editPermission('update')}}},[_vm._v(_vm._s(_vm.$t("update")))]):_vm._e()],1)],1),_c('v-row',[_c('v-col',{staticStyle:{"padding-left":"45px"},attrs:{"cols":"12"}},[_c('span',[_vm._v(_vm._s(_vm.$t("usage")))])]),_c('v-col',{staticStyle:{"padding-left":"57px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-3",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:([
            _vm.editing_UsageType == true && _vm.mobileOrWebUsage_Permission == 2
              ? {
                  'background-color': '#0000001f !important',
                  color: '#424242 !important',
                }
              : _vm.editing_UsageType == false && _vm.mobileOrWebUsage_Permission == 1
              ? {
                  'background-color': '#ffffff',
                  color: '#A6CC39',
                  border: '1px solid #A6CC39',
                }
              : !_vm.editing_UsageType == false &&
                _vm.mobileOrWebUsage_Permission == 1
              ? {
                  'background-color': '#ffffff !important',
                  color: '#424242 !important',
                  border: '1px solid #CCCCCC !important',
                }
              : { 'background-color': '#A6CC39', color: '#ffffff' },
          ]),attrs:{"disabled":_vm.editing_UsageType},on:{"click":function($event){_vm.mobileOrWebUsage_Permission = 2}}},[_vm._v(_vm._s(_vm.$t("mobileonly")))]),_c('v-btn',{staticClass:"text-capitalize ml-3",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:([
            _vm.editing_UsageType == true && _vm.mobileOrWebUsage_Permission == 1
              ? {
                  'background-color': '#0000001f !important',
                  color: '#424242 !important',
                }
              : _vm.editing_UsageType == false && _vm.mobileOrWebUsage_Permission == 2
              ? {
                  'background-color': '#ffffff',
                  color: '#A6CC39',
                  border: '1px solid #A6CC39',
                }
              : !_vm.editing_UsageType == false &&
                _vm.mobileOrWebUsage_Permission == 2
              ? {
                  'background-color': '#ffffff !important',
                  color: '#424242 !important',
                  border: '1px solid #CCCCCC !important',
                }
              : { 'background-color': '#A6CC39', color: '#ffffff' },
          ]),attrs:{"disabled":_vm.editing_UsageType},on:{"click":function($event){_vm.mobileOrWebUsage_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("web&mobile")))])],1)],1),_c('v-divider',{staticClass:"mt-7 mb-7",staticStyle:{"border":"1px solid #a6cc39"}}),_c('v-row',{staticClass:"pl-5 accessright"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("accessrights"))+" ")])]),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('library')},model:{value:(_vm.library_Checked),callback:function ($$v) {_vm.library_Checked=$$v},expression:"library_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.library_Checked == true
                  ? [
                      !_vm.library_Checked == true && _vm.library_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.library_Checked == true && _vm.library_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.library_Checked == false
                  ? [
                      !_vm.library_Checked == true && _vm.library_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.library_Checked == true && _vm.library_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.library_Checked || _vm.editing},on:{"click":function($event){_vm.library_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.library_Checked == true
                  ? [
                      !_vm.library_Checked == true && _vm.library_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.library_Checked == true && _vm.library_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.library_Checked == false && _vm.library_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.library_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.library_Checked == false
                  ? [
                      !_vm.library_Checked == true && _vm.library_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.library_Checked == false && _vm.library_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.library_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.library_Checked == true && _vm.library_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.library_Checked == false && _vm.library_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.library_Checked == false && _vm.library_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.library_Checked || _vm.editing},on:{"click":function($event){_vm.library_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('lessonlearn')},model:{value:(_vm.lessonlearn_Checked),callback:function ($$v) {_vm.lessonlearn_Checked=$$v},expression:"lessonlearn_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.lessonlearn_Checked == true
                  ? [
                      !_vm.lessonlearn_Checked == true &&
                      _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.lessonlearn_Checked == true &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.lessonlearn_Checked == false
                  ? [
                      !_vm.lessonlearn_Checked == true &&
                      _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.lessonlearn_Checked == true &&
                      _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.lessonlearn_Checked || _vm.editing},on:{"click":function($event){_vm.lessonLearn_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.lessonlearn_Checked == true
                  ? [
                      !_vm.lessonlearn_Checked == true &&
                      _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.lessonlearn_Checked == true &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.lessonlearn_Checked == false
                  ? [
                      !_vm.lessonlearn_Checked == true &&
                      _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.lessonlearn_Checked == true &&
                      _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.lessonlearn_Checked == false &&
                          _vm.lessonLearn_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.lessonlearn_Checked || _vm.editing},on:{"click":function($event){_vm.lessonLearn_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('course')},model:{value:(_vm.course_Checked),callback:function ($$v) {_vm.course_Checked=$$v},expression:"course_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.course_Checked == true
                  ? [
                      !_vm.course_Checked == true && _vm.course_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.course_Checked == true && _vm.course_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.course_Checked == false
                  ? [
                      !_vm.course_Checked == true && _vm.course_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.course_Checked == true && _vm.course_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.course_Checked || _vm.editing},on:{"click":function($event){_vm.course_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.course_Checked == true
                  ? [
                      !_vm.course_Checked == true && _vm.course_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.course_Checked == true && _vm.course_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.course_Checked == false
                  ? [
                      !_vm.course_Checked == true && _vm.course_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.course_Checked == true && _vm.course_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.course_Checked == false && _vm.course_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.course_Checked || _vm.editing},on:{"click":function($event){_vm.course_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('quiz')},model:{value:(_vm.quiz_Checked),callback:function ($$v) {_vm.quiz_Checked=$$v},expression:"quiz_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.quiz_Checked == true
                  ? [
                      !_vm.quiz_Checked == true && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.quiz_Checked == true && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.quiz_Checked == false
                  ? [
                      !_vm.quiz_Checked == true && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.quiz_Checked == true && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.quiz_Checked || _vm.editing},on:{"click":function($event){_vm.quiz_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.quiz_Checked == true
                  ? [
                      !_vm.quiz_Checked == true && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.quiz_Checked == true && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.quiz_Checked == false
                  ? [
                      !_vm.quiz_Checked == true && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.quiz_Checked == true && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.quiz_Checked == false && _vm.quiz_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.quiz_Checked || _vm.editing},on:{"click":function($event){_vm.quiz_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('community')},model:{value:(_vm.community_Checked),callback:function ($$v) {_vm.community_Checked=$$v},expression:"community_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.community_Checked == true
                  ? [
                      !_vm.community_Checked == true && _vm.community_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.community_Checked == true &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.community_Checked == false
                  ? [
                      !_vm.community_Checked == true && _vm.community_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.community_Checked == true && _vm.community_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.community_Checked || _vm.editing},on:{"click":function($event){_vm.community_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.community_Checked == true
                  ? [
                      !_vm.community_Checked == true && _vm.community_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.community_Checked == true &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.community_Checked == false
                  ? [
                      !_vm.community_Checked == true && _vm.community_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.community_Checked == true && _vm.community_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.community_Checked == false &&
                          _vm.community_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.community_Checked || _vm.editing},on:{"click":function($event){_vm.community_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('event')},model:{value:(_vm.event_Checked),callback:function ($$v) {_vm.event_Checked=$$v},expression:"event_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.event_Checked == true
                  ? [
                      !_vm.event_Checked == true && _vm.event_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.event_Checked == true && _vm.event_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.event_Checked == false
                  ? [
                      !_vm.event_Checked == true && _vm.event_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.event_Checked == true && _vm.event_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.event_Checked || _vm.editing},on:{"click":function($event){_vm.event_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.event_Checked == true
                  ? [
                      !_vm.event_Checked == true && _vm.event_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.event_Checked == true && _vm.event_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.event_Checked == false
                  ? [
                      !_vm.event_Checked == true && _vm.event_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.event_Checked == true && _vm.event_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.event_Checked == false && _vm.event_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.event_Checked || _vm.editing},on:{"click":function($event){_vm.event_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('banner')},model:{value:(_vm.banner_Checked),callback:function ($$v) {_vm.banner_Checked=$$v},expression:"banner_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.banner_Checked == true
                  ? [
                      !_vm.banner_Checked == true && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.banner_Checked == true && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.banner_Checked == false
                  ? [
                      !_vm.banner_Checked == true && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.banner_Checked == true && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.banner_Checked || _vm.editing},on:{"click":function($event){_vm.banner_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.banner_Checked == true
                  ? [
                      !_vm.banner_Checked == true && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.banner_Checked == true && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.banner_Checked == false
                  ? [
                      !_vm.banner_Checked == true && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.banner_Checked == true && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.banner_Checked == false && _vm.banner_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.banner_Checked || _vm.editing},on:{"click":function($event){_vm.banner_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('feedbackbox')},model:{value:(_vm.feedbackbox_Checked),callback:function ($$v) {_vm.feedbackbox_Checked=$$v},expression:"feedbackbox_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.feedbackbox_Checked == true
                  ? [
                      !_vm.feedbackbox_Checked == true &&
                      _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.feedbackbox_Checked == true &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.feedbackbox_Checked == false
                  ? [
                      !_vm.feedbackbox_Checked == true &&
                      _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.feedbackbox_Checked == true &&
                      _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.feedbackbox_Checked || _vm.editing},on:{"click":function($event){_vm.feedbackbox_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.feedbackbox_Checked == true
                  ? [
                      !_vm.feedbackbox_Checked == true &&
                      _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.feedbackbox_Checked == true &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.feedbackbox_Checked == false
                  ? [
                      !_vm.feedbackbox_Checked == true &&
                      _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.feedbackbox_Checked == true &&
                      _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.feedbackbox_Checked == false &&
                          _vm.feedbackbox_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.feedbackbox_Checked || _vm.editing},on:{"click":function($event){_vm.feedbackbox_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('usermanagement')},model:{value:(_vm.usermanage_Checked),callback:function ($$v) {_vm.usermanage_Checked=$$v},expression:"usermanage_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.usermanage_Checked == true
                  ? [
                      !_vm.usermanage_Checked == true &&
                      _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.usermanage_Checked == true &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.usermanage_Checked == false
                  ? [
                      !_vm.usermanage_Checked == true &&
                      _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.usermanage_Checked == true && _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.usermanage_Checked || _vm.editing},on:{"click":function($event){_vm.usermanage_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.usermanage_Checked == true
                  ? [
                      !_vm.usermanage_Checked == true &&
                      _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.usermanage_Checked == true &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.usermanage_Checked == false
                  ? [
                      !_vm.usermanage_Checked == true &&
                      _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.usermanage_Checked == true && _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.usermanage_Checked == false &&
                          _vm.usermanage_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.usermanage_Checked || _vm.editing},on:{"click":function($event){_vm.usermanage_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('companyprofile')},model:{value:(_vm.companyProfile_Checked),callback:function ($$v) {_vm.companyProfile_Checked=$$v},expression:"companyProfile_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.companyProfile_Checked == true
                  ? [
                      !_vm.companyProfile_Checked == true &&
                      _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.companyProfile_Checked == true &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.companyProfile_Checked == false
                  ? [
                      !_vm.companyProfile_Checked == true &&
                      _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.companyProfile_Checked == true &&
                      _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.companyProfile_Checked || _vm.editing},on:{"click":function($event){_vm.companyProfile_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.companyProfile_Checked == true
                  ? [
                      !_vm.companyProfile_Checked == true &&
                      _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.companyProfile_Checked == true &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.companyProfile_Checked == false
                  ? [
                      !_vm.companyProfile_Checked == true &&
                      _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.companyProfile_Checked == true &&
                      _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.companyProfile_Checked == false &&
                          _vm.companyProfile_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.companyProfile_Checked || _vm.editing},on:{"click":function($event){_vm.companyProfile_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('sendnotification')},model:{value:(_vm.sendnoti_Checked),callback:function ($$v) {_vm.sendnoti_Checked=$$v},expression:"sendnoti_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.sendnoti_Checked == true
                  ? [
                      !_vm.sendnoti_Checked == true && _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.sendnoti_Checked == true &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.sendnoti_Checked == false
                  ? [
                      !_vm.sendnoti_Checked == true && _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.sendnoti_Checked == true && _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.sendnoti_Checked || _vm.editing},on:{"click":function($event){_vm.sendnoti_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.sendnoti_Checked == true
                  ? [
                      !_vm.sendnoti_Checked == true && _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.sendnoti_Checked == true &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.sendnoti_Checked == false
                  ? [
                      !_vm.sendnoti_Checked == true && _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.sendnoti_Checked == true && _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.sendnoti_Checked == false &&
                          _vm.sendnoti_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.sendnoti_Checked || _vm.editing},on:{"click":function($event){_vm.sendnoti_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('setting') + ' - ' + _vm.$t('notification')},model:{value:(_vm.settingNoti_Checked),callback:function ($$v) {_vm.settingNoti_Checked=$$v},expression:"settingNoti_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.settingNoti_Checked == true
                  ? [
                      !_vm.settingNoti_Checked == true &&
                      _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.settingNoti_Checked == true &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.settingNoti_Checked == false
                  ? [
                      !_vm.settingNoti_Checked == true &&
                      _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.settingNoti_Checked == true &&
                      _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.settingNoti_Checked || _vm.editing},on:{"click":function($event){_vm.settingNoti_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.settingNoti_Checked == true
                  ? [
                      !_vm.settingNoti_Checked == true &&
                      _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.settingNoti_Checked == true &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.settingNoti_Checked == false
                  ? [
                      !_vm.settingNoti_Checked == true &&
                      _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.settingNoti_Checked == true &&
                      _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.settingNoti_Checked == false &&
                          _vm.settingNoti_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.settingNoti_Checked || _vm.editing},on:{"click":function($event){_vm.settingNoti_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('store')},model:{value:(_vm.store_Checked),callback:function ($$v) {_vm.store_Checked=$$v},expression:"store_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.store_Checked == true
                  ? [
                      !_vm.store_Checked == true && _vm.store_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.store_Checked == true && _vm.store_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.store_Checked == false
                  ? [
                      !_vm.store_Checked == true && _vm.store_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.store_Checked == true && _vm.store_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.store_Checked || _vm.editing},on:{"click":function($event){_vm.store_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.store_Checked == true
                  ? [
                      !_vm.store_Checked == true && _vm.store_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.store_Checked == true && _vm.store_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.store_Checked == false
                  ? [
                      !_vm.store_Checked == true && _vm.store_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.store_Checked == true && _vm.store_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.store_Checked == false && _vm.store_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.store_Checked || _vm.editing},on:{"click":function($event){_vm.store_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('dashboard')},model:{value:(_vm.dashboard_Checked),callback:function ($$v) {_vm.dashboard_Checked=$$v},expression:"dashboard_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.dashboard_Checked == true
                  ? [
                      !_vm.dashboard_Checked == true &&
                       _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.dashboard_Checked == true &&
                           _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.dashboard_Checked == false &&
                           _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.dashboard_Checked == false
                  ? [
                      !_vm.dashboard_Checked == true &&
                      _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.dashboard_Checked == false &&
                           _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.dashboard_Checked == true &&
                      _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.dashboard_Checked == false &&
                           _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.dashboard_Checked || _vm.editing},on:{"click":function($event){_vm.dashboard_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.dashboard_Checked == true
                  ? [
                      !_vm.dashboard_Checked == true &&
                       _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.dashboard_Checked == true &&
                           _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.dashboard_Checked == false &&
                           _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.dashboard_Checked == false
                  ? [
                      !_vm.dashboard_Checked == true &&
                       _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.dashboard_Checked == false &&
                           _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.dashboard_Checked == true &&
                      _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.dashboard_Checked == false &&
                          _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.dashboard_Checked == false &&
                           _vm.dashboard_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.dashboard_Checked || _vm.editing},on:{"click":function($event){_vm.dashboard_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("filter")))])],1)],1)],1),_c('v-col',[_c('v-row',[_c('v-col',{staticClass:"pl-4",attrs:{"cols":"12"}},[_c('v-checkbox',{staticClass:"permission_checkbox",attrs:{"disabled":_vm.editing,"hide-details":"","color":"#a6cc39","label":_vm.$t('trainingroadmapiso')},model:{value:(_vm.skillMatrix_Checked),callback:function ($$v) {_vm.skillMatrix_Checked=$$v},expression:"skillMatrix_Checked"}})],1),_c('v-col',{staticStyle:{"padding-left":"60px"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"text-capitalize mr-6",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.skillMatrix_Checked == true
                  ? [
                      !_vm.skillMatrix_Checked == true &&
                      _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.skillMatrix_Checked == true &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.skillMatrix_Checked == false
                  ? [
                      !_vm.skillMatrix_Checked == true &&
                      _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.skillMatrix_Checked == true &&
                      _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.skillMatrix_Checked || _vm.editing},on:{"click":function($event){_vm.skillMatrix_Permission = 0}}},[_vm._v(_vm._s(_vm.$t("View")))]),_c('v-btn',{staticClass:"text-capitalize",staticStyle:{"font-size":"14px","border-radius":"5px","box-shadow":"unset"},style:(_vm.editing == false && _vm.skillMatrix_Checked == true
                  ? [
                      !_vm.skillMatrix_Checked == true &&
                      _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.skillMatrix_Checked == true &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : _vm.editing == false && _vm.skillMatrix_Checked == false
                  ? [
                      !_vm.skillMatrix_Checked == true &&
                      _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : !_vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]
                  : [
                      _vm.skillMatrix_Checked == true &&
                      _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 1
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#0000001f !important',
                            color: '#424242 !important',
                          }
                        : _vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#ffffff',
                            color: '#A6CC39',
                            border: '1px solid #A6CC39',
                          }
                        : !_vm.skillMatrix_Checked == false &&
                          _vm.skillMatrix_Permission == 0
                        ? {
                            'background-color': '#ffffff !important',
                            color: '#424242 !important',
                            border: '1px solid #CCCCCC !important',
                          }
                        : { 'background-color': '#A6CC39', color: '#ffffff' },
                    ]),attrs:{"disabled":!_vm.skillMatrix_Checked || _vm.editing},on:{"click":function($event){_vm.skillMatrix_Permission = 1}}},[_vm._v(_vm._s(_vm.$t("add") + "," + _vm.$t("edit") + "," + _vm.$t("delete")))])],1)],1)],1)],1),_c('v-divider',{staticClass:"mt-7 mb-7",staticStyle:{"border":"1px solid #a6cc39"}}),_c('v-row',{staticClass:"mb-2"},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{staticStyle:{"font-size":"20px","color":"#424242"}},[_vm._v(_vm._s(_vm.$t("reports")))])]),_c('v-col',{attrs:{"cols":"3"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('useractivityrp'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.userActivity_Checked),callback:function ($$v) {_vm.userActivity_Checked=$$v},expression:"userActivity_Checked"}})],1),_c('v-col',{attrs:{"cols":"3"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('usercourserp'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.userCourse_Checked),callback:function ($$v) {_vm.userCourse_Checked=$$v},expression:"userCourse_Checked"}})],1),_c('v-col',{attrs:{"cols":"3"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('contentviewrp'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.userView_Checked),callback:function ($$v) {_vm.userView_Checked=$$v},expression:"userView_Checked"}})],1),_c('v-col',{attrs:{"cols":"3"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('requesteduserreport'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.requestedUserRp_Checked),callback:function ($$v) {_vm.requestedUserRp_Checked=$$v},expression:"requestedUserRp_Checked"}})],1),_c('v-col',{attrs:{"cols":"3"}},[_c('v-checkbox',{staticClass:"permission_checkbox mr-3",attrs:{"disabled":_vm.editing,"label":_vm.$t('ACReport'),"color":"#a6cc39","hide-details":""},model:{value:(_vm.acReport_Checked),callback:function ($$v) {_vm.acReport_Checked=$$v},expression:"acReport_Checked"}})],1)],1)],1),_c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-card',{attrs:{"color":"#4FB14E","dark":""}},[_c('v-card-text',{staticClass:"white--text"},[_vm._v(" Loading Please Wait... "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"#ffffff"}})],1)],1)],1),_c('PermissionDialog',{attrs:{"show":_vm.permissionDialog,"title":"Error","text":_vm.permissionMessage},on:{"close":function($event){_vm.permissionDialog = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }